import { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { MenuOutlined } from "@ant-design/icons";
import { useMsal } from "@azure/msal-react";
import { logout } from "../../../services/authService";
import styles from "./NavBar.module.css";
import findmoreLogoIcon from "../../../assets/icons/findmore_logo.svg";

export type NavItem = {
  key: string;
  label: string;
  path: string;
};

type NavBarProps = {
  items: NavItem[];
  showLogout?: boolean;
};

export default function NavBar({ items, showLogout = true }: NavBarProps) {
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const [availableHeight, setAvailableHeight] = useState(window.innerHeight);
  const { instance } = useMsal();

  const handleLogout = () => {
    sessionStorage.removeItem("hasSeenEvaluationModal");
    logout(instance);
  };

  useEffect(() => {
    if (!menuOpen) return;

    const navbar = document.querySelector("header");
    const footer = document.querySelector("footer");
    const navbarHeight = navbar?.getBoundingClientRect().height ?? 0;

    function calculateHeight() {
      const screenHeight = window.innerHeight;

      if (footer) {
        const footerRect = footer.getBoundingClientRect();

        if (footerRect.top >= screenHeight) {
          setAvailableHeight(screenHeight - navbarHeight);
        } 
        else {
          setAvailableHeight(footerRect.top - navbarHeight);
        }
      } else {
        setAvailableHeight(screenHeight - navbarHeight);
      }
    }

    calculateHeight();

    window.addEventListener("scroll", calculateHeight);
    window.addEventListener("resize", calculateHeight);

    return () => {
      window.removeEventListener("scroll", calculateHeight);
      window.removeEventListener("resize", calculateHeight);
    };
  }, [menuOpen]);

  return (
    <header className={styles.navbar}>
      <div className={styles.inner}>
        {/* Mobile Toggle */}
        {items.length > 0 && (
          <button className={styles.menuToggle} onClick={() => setMenuOpen(!menuOpen)}>
            <MenuOutlined />
          </button>
        )}

        {/* Logo */}
        <img src={findmoreLogoIcon} alt="Findmore Solutions" className={styles.logo} onClick={() => navigate("/")}/>

        {/* Nav Links */}
        {items.length > 0 && (
          <nav
            className={`${styles.navLinks} ${menuOpen ? styles.open : ""}`}
            style={menuOpen ? { height: availableHeight } : undefined}
          >
            {items.map((item) => (
              <button
                key={item.key}
                className={`${styles.link} ${
                  location.pathname === item.path ? styles.active : ""
                }`}
                onClick={() => {
                  navigate(item.path);
                  setMenuOpen(false);
                }}
              >
                {item.label}
              </button>
            ))}

            {/* Logout Button */}
            {showLogout && (
              <button className={styles.logoutButton} onClick={handleLogout}>
                <span>Terminar sessão</span>
              </button>
            )}
          </nav>
        )}
      </div>
    </header>
  );
}